// extracted by mini-css-extract-plugin
module.exports = {"SocialLinks":"blog-social_SocialLinks__QUPt8","Link":"blog-social_Link__saeLY","Copy":"blog-social_Copy__SfjVg","Copied":"blog-social_Copied__zXxdk"};